<template lang='pug'>
//- 團隊廠商 Feature列表
div(:class='$style[`cc-popbox-team-feature`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.no-wrap 所有服務
        //- span.font-doctor-theme 相關
        //- span.font-normal-theme 服務

    div(:class='$style[`cc-feature-content`]')
      ul(:class='$style[`cc-feature-ul`]')
        li(v-for='items, index in features' :key='index' :class='$style[`cc-feature-li`]')
          a(:class='$style[`cc-feature-link`]' :href='items.link') {{ items.feature_name }}

</template>

<script>
import { mapMutations } from 'vuex';

export default {
  props: {
    features: {
      type: Array,
      default: null,
    },
  },

  methods: {
    ...mapMutations({
      changePopTeamFeatureStatus: 'global/POPTEAM_FEATURE_STATUS',
    }),

    handleClosePopBox() {
      this.changePopTeamFeatureStatus({
        active: false,
        features: '',
      });
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popTeamFeature.scss';
</style>
